import { FluidDropdown } from '../../../../components/ui/fluid-dropdown';
import { DropdownOption } from '../../../../types';

interface SearchDropdownProps {
  selectedOption: DropdownOption | undefined;
  options: DropdownOption[] | undefined;
  placeholder: string;
  onSelect: (option: DropdownOption) => void;
}

function SearchDropdown({ selectedOption, options, placeholder, onSelect }: SearchDropdownProps) {
  return (
    <FluidDropdown
      selectedOption={selectedOption}
      options={options}
      placeholder={placeholder}
      onSelect={onSelect}
    />
  );
}

export default SearchDropdown;
